import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import { BodyLargeBold, BodySmall, BodySmallMedium } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const Container = styled.article`
  width: 100%;
  max-height: 534px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${LayoutColors.gray};
  border-radius: 4px;

  ${device.mediumTablet} {
    max-height: 736px;
  }
`;

export const PackageProductWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    border-bottom: 1px solid ${LayoutColors.grayMain};
    padding-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const Product = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${LayoutColors.grayMain};
  padding: 16px;

  &:last-of-type {
    margin-bottom: 16px;
  }
`;

export const ProductName = styled.p`
  ${BodyLargeBold};
  text-align: left;
`;

export const PackageDates = styled.p`
  ${BodySmallMedium}
  text-align: left;
  margin-top: 8px;
  color: ${LayoutColors.blackMain};
`;

export const PackageTariffInfo = styled.p`
  ${BodySmallMedium}
  margin-top: 8px;
  text-align: left;
`;

export const PackagePriceInfo = styled('div')`
  display: flex;
  justify-content: space-between;
  ${BodySmall}
`;

export const PackagePrices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

export const PackageOriginalPrice = styled.span`
  color: ${LayoutColors.blackMain};
  ${BodySmallMedium}
`;

export const PackageDiscountValue = styled.span`
  color: ${LayoutColors.greenDark};
  ${BodySmallMedium}
`;

export const PackageTotalPrice = styled.span`
  ${BodyLargeBold}
`;

export const PackageProductDetails = styled.span`
  ${BodySmallMedium}
`;

export const PackageProductDetailsContent = styled.div`
  padding-top: 8px;
`;
